export default {
  namespaced: true,
  state: {
    haveError: '',
    alertCountDown: 0,
    defaultErrorAlertSecs: 10
  },
  mutations: {
    errorOccurred(state, message) {
      state.haveError = message
      state.alertCountDown = state.defaultErrorAlertSecs
    },
    clearError(state) {
      state.haveError = ''
      state.alertCountDown = 0
    },
    alertCountDownChanged(state, dismissCountDown) {
      state.alertCountDown = dismissCountDown
    },
  }
}